export default __webpack_public_path__ + "static/media/countdown.74134f70.mp3";